<template>
  <div :class="useIsMobile().value ? 'k__gifts-card' : 'k__gifts-card k__pc__gifts-card'">
    <!-- <div :class="useIsMobile().value ? 'gift-item gift-item-type-1' : 'gift-item'">Loading...</div> -->
    <div
      v-for="(gift, idx) in (gifts || [])"
      :key="idx"
      class="gift-item"
      @click="handleGiftClick(gift)"
    >
      <span v-if="type === 'checkout'" class="free-gifts">[Free Gifts]</span>
      <img class="gift-img" :src="$cvWebpFn(gift.giftSkuImg || 'https://image.kilimall.com/lite/new_wap/ic_free_gifts.png')" alt="">
      <p class="gift-title-text">{{ gift.giftSkuTitle }}</p>
      <div class="total">
        <span>x{{ gift.giftNumber }}</span>
        <van-icon v-if="type === 'shopping-cart'" class="total-icon"  name="arrow" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
export interface IGifts {
  id?: number;
  giftSkuId: number;
  giftSkuTitle: string;
  buyNumber?: number;
  giftNumber: number;
  giftSkuImg?: string;
}
interface IProps {
  gifts: IGifts[],
  type?: 'product' | 'shopping-cart' | 'checkout'
  defaultIsClick?: boolean;
}
interface IEmits {
  (e: 'gift:click', val: IGifts): void
}

const props = withDefaults(
  defineProps<IProps>(),
  {
    type: 'product',
    defaultIsClick: true
  }
)
const emits = defineEmits<IEmits>()
const { $toListingDetail } = useNuxtApp()

const handleGiftClick = (val: IGifts) => {
  if(props.defaultIsClick) {
    $toListingDetail(val.giftSkuId, { type: 'sku', title: val.giftSkuTitle })
  }

  emits('gift:click', val)
}
</script>

<style lang="scss" scoped>
.k__gifts-card{
  .gift-item{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 15px 0;
    color: #666;
    font-size: 26px;
    cursor: pointer;
    height: 60px;
    line-height: 60px;
    .gift-img{
      width: 60px;
      height: 60px;
      object-fit: contain;
    }
    .gift-title-text{
      flex: 1;
      padding: 0 20px;
      font-size: 26px;
      @include ellipsisMultiline(1);
    }
    .free-gifts{
      font-size: 26px;
      margin-right: 10px;
    }
    .total{
      text-align: right;
      font-size: 26px;
      color: #666;
      .total-icon{
        font-size: 32px;
        margin-left: 10px;
      }
    }
  }
  // 后续其他类型加 class 就可以了
  .gift-item-type-1{
    background-image: url('https://image.kilimall.com/lite/new_wap/ic_free_gifts.png.webp');
    background-repeat: no-repeat;
    background-size: 30px 30px;
    background-position: 10px center;
    padding-left: 50px;
  }
}
.k__pc__gifts-card .gift-item{
  font-size: 28px;
  color: #666;
  justify-content: flex-start;
  .gift-title{
    flex: none;
    @include ellipsisMultiline(1);
  }
  .total{
    font-size: 28px;
    color: #666;
  }
}
</style>